import * as React from "react";
import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps";
import { compose, withProps } from "recompose";
import Marker from "react-google-maps/lib/components/Marker";
import PlaceResult = google.maps.places.PlaceResult;

import StandaloneSearchBox from "react-google-maps/lib/components/places/StandaloneSearchBox";
import { TextField } from "@material-ui/core";

export class Dot {
  lat: any;
  lng: any;

  constructor(latitude: number, longitude: number) {
    this.lat = latitude;
    this.lng = longitude;
  }
}

interface MapProps {
  zoom: number;
  center: Dot;
  street?: any;
  refStreet: StandaloneSearchBox;
  activeForm: boolean;
  changeLocation: (location: any) => void;
  changeStreet: (location: any) => void;
  changeAddress: (ref: StandaloneSearchBox) => void;
}

const LocationMap: React.SFC<MapProps> = (props: MapProps) => {
  const {
    center,
    zoom,
    street,
    refStreet,
    changeStreet,
    changeLocation,
    changeAddress,
    activeForm,
  } = props;

  const onPlaceSelected = () => {
    return () => {
      setNewPlace(refStreet);
    };
  };

  const setNewPlace = (ref: StandaloneSearchBox) => {
    const places: PlaceResult[] = ref.getPlaces();
    const bounds = new google.maps.LatLngBounds();

    places.forEach((place: PlaceResult | undefined) => {
      if (place && place.geometry && place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        if (place && place.geometry && place.geometry.location) {
          bounds.extend(place.geometry.location);
        }
      }
    });

    const nextMarkers = places.map((place: PlaceResult) => {
      if (place && place.geometry && place.geometry.location) {
        return {
          position: place.geometry.location,
        };
      } else {
        return { position: center };
      }
    });

    const nextCenter =
      (nextMarkers && nextMarkers[0] && nextMarkers[0].position) || center;
    const centerDot = new Dot(nextCenter.lat(), nextCenter.lng());
    changeLocation(centerDot);
  };

  const handleOnClick = (
    args: google.maps.MouseEvent | google.maps.IconMouseEvent
  ) => {
    console.log("click en maps");
    const newLocation = new Dot(args.latLng.lat(), args.latLng.lng());
    changeLocation(newLocation);
  };

  const handleDragEnd = () => {
    return (e: google.maps.MouseEvent) => {
      console.log("event marker", e);

      const newLocation = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      changeLocation(newLocation);
    };
  };

  return (
    <>
      {!activeForm && (
        <div style={{ top: 60, position: "absolute", width: "80%" }}>
          <StandaloneSearchBox
            ref={changeAddress}
            onPlacesChanged={onPlaceSelected()}
          >
            <TextField
              id="street"
              label="Buscar una dirección en el mapa"
              value={street}
              onChange={(e) => changeStreet(e.target.value)}
              style={{
                width: "100%",
              }}
              margin="normal"
              placeholder="Ingrese una dirección, ciudad"
            />
          </StandaloneSearchBox>
        </div>
      )}

      <GoogleMap defaultZoom={zoom} center={center} onClick={handleOnClick}>
        <Marker
          draggable
          onDragEnd={handleDragEnd()}
          position={center}
          label={{ text: "O", color: "white" }}
        />
      </GoogleMap>
    </>
  );
};

export default compose<any, MapProps>(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyAcZVbIDdV7dM8nAiIPsCXnjUY51gXZPJI`,
    loadingElement: <div style={{ minHeight: "100%" }} />,
    containerElement: (
      <div
        style={{ height: `400px`, paddingLeft: `15px`, paddingBottom: `15px` }}
      />
    ),
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(LocationMap);



// WEBPACK FOOTER //
// ./src/components/LocationMap.tsx